export default "__VITE_ASSET__ZfyaBFMY__"